const Quarter = [
  {
    label: "Quarter 1",
    value: 1
  },
  {
    label: "Quarter 2",
    value: 2
  },
  {
    label: "Quarter 3",
    value: 3
  },
  {
    label: "Quarter 4",
    value: 4
  }
]

export default Quarter